import React from "react";
import { Route, Routes } from "react-router-dom";
import { CustomersList } from "./list";
import { CustomerInfo } from "./details";

const CustomersModule = () => {
  return (
    <Routes>
      <Route index element={<CustomersList />} />
      <Route path="details/:customerId" element={<CustomerInfo />} />
    </Routes>
  );
};

export default CustomersModule;
